import type {
  AddressData,
  PonyfillFactoryCredentials,
  UserData,
  RetorikThemeColors,
} from '@davi-ai/retorik-framework';

const tenants: { [key: string]: AddressData } = {
  activital: {
    tenant: 'activital'
  }
}
const userData: UserData = {
  name: '',
  id: Math.random().toString(36).substring(2, 9),
  username: '',
  nom: '',
  prenom: '',
  email: '',
  token: '',
  referrer: '',
  ipaddress: ''
}

const logoDefault ="images/logoACTIVITAL.png";

const ponyfillFactoryCredentials: PonyfillFactoryCredentials = {
  region: 'francecentral',
  subscriptionKey: '2f62867e22a544b78a16c99a2707ef49'
}

const voices = {
  guy: {
    voice: 'GuyNeural'
  },
  henri: {
    voice: 'HenriNeural'
  },
  multiMale:{
    voice:"en-US-RyanMultilingualNeural"
  },
  multi: {
    voice: 'EmmaMultilingualNeural'
  }
}
//•	Couleur principale (application sur fond foncé) : #FFA500
//•	Couleur secondaire (application sur fond clair) : #0d8ba2

const colorOnLight = "#0d8ba2";
const colorOnDark = "#FFA500";
const commonColors = {
  primary: '#FFA500',
  secondary: colorOnLight,
  black: '#101219',
  whereToEatColor: '#FC952E',
  whereToSleepColor: '#9F007D',
  tobeSeenColor: '#76AB2A',
  tobeDoneColor: '#E23C2A',
  localProductsColor: '#AFB942',
  servicesColor: '#00C8BC',
  agendaColor: '#865DA2'
}

const colors : RetorikThemeColors = {
  ...commonColors,
  theme:"dark",
  companyName: '#000',
  loader: {
    animation: colorOnDark,
    background: 'rgba(18,18,18,0.7)',
    text: '#FFF',
    toggle: {
      text: '#000',
      background: colorOnDark
    },
    button: {
      background: {
        default: 'transparent',
        hover: 'transparent'
      },
      border: {
        default: colorOnDark,
        hover: '#FFF'
      },
      text: {
        default: colorOnDark,
        hover: '#FFF'
      }
    }
  },
  card: {
    frame: {
      background: "#2b2b2b",
      border: 'transparent',
      text: '#F7F3F6'
    },
    button: {
      background: {
        default: 'transparent',
        hover: 'transparent'
      },
      border: {
        default: colorOnDark,
        hover: '#FFF'
      },
      text: {
        default: colorOnDark,
        hover: '#FFF'
      }
    }
  },
  textMode: {
    panel: {
      background: 'rgba(255, 255, 255, 0.9)',
      border: 'transparent',
      conversationUser: '#101219',
      conversationBot: commonColors.secondary
    }
  },
  vocalMode: {
    subtitles: {
      text: '#FFF',
      background: '#000'
    }
  },
  formInput: {
    text: {
      default: colorOnLight,
      hover: '#FFF'
    },
    inputRadioCheckbox: {
      unchecked: {
        background: '#434141',
        border: '#818181'
      },
      checked: {
        background: commonColors.primary,
        border: commonColors.primary,
        item: '#000'
      }
    },
    inputButton: {
      background: {
        default: commonColors.black,
        hover: commonColors.primary
      },
      border: {
        default: commonColors.primary,
        hover: '#FFF'
      },
      text: {
        default: '#FFF',
        hover: '#FFF'
      }
    },
    likert: {
      default: 'transparent',
      hover: '#E8B712'
    }
  }
}

export {
  userData,
  ponyfillFactoryCredentials,
  voices,
  colors,
  tenants,
  logoDefault
}
